import { createApp } from 'vue'

import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './firebase/firebase'
import VueFinalModal from 'vue-final-modal/lib'
import Maska from 'maska'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add( fas )

const app = createApp(App)

app.use( router )
app.use( store )
app.use( VueFinalModal() )

app.component( 'font-awesome-icon', FontAwesomeIcon )
app.component( 'font-awesome-layers', FontAwesomeLayers )
app.component( 'font-awesome-layers-text', FontAwesomeLayersText )

app.directive( 'maska', Maska.maska )

app.mount( '#app' )
